/**
 * Elle Exist — product rail ("Complete the look").
 * Ported from the Nucery (Space/Impulse) theme.
 *
 * Recommendations come from Shopify's JSON API, recently-viewed from the
 * theme-recent localStorage list. Cards are built here when the section did
 * not arrive server-rendered.
 *
 * Palo Alto changes: Flickity is read from window.theme.Flickity; the rail no
 * longer adds to cart itself — each bag is a real form whose button carries
 * data-add-to-cart, and Palo Alto's cart (listening on the document) adds the
 * item and opens its drawer. Products with options are intercepted before
 * that by ee-quick-add.js.
 */
(function () {
  'use strict';

  if (window.__eeProductRailJS) {
    return;
  }
  window.__eeProductRailJS = 1;

  function shopRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function flickityCtor() {
    return window.Flickity || (window.theme && window.theme.Flickity) || null;
  }

  function formatMoney(cents, moneyFormat) {
    if (window.theme && typeof window.theme.formatMoney === 'function' && moneyFormat) {
      return window.theme.formatMoney(cents, moneyFormat);
    }
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var formatString = moneyFormat || '${{amount}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var match = formatString.match(placeholder);
    if (!match) {
      return String(cents);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) {
        return '0';
      }
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? decimal + parts[1] : '';
      return dollarsAmount + centsAmount;
    }

    switch (match[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }
    return formatString.replace(placeholder, value);
  }

  function escapeHtml(str) {
    if (str == null) {
      return '';
    }
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function featuredImageSrc(product) {
    var fi = product.featured_image;
    if (!fi) {
      if (product.images && product.images[0]) {
        var im = product.images[0];
        return typeof im === 'string' ? im : im.src || im;
      }
      return '';
    }
    return typeof fi === 'string' ? fi : fi.src || '';
  }

  function firstAvailableVariant(product) {
    if (!product.variants || !product.variants.length) {
      return null;
    }
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].available) {
        return product.variants[i];
      }
    }
    return product.variants[0];
  }

  function priceLabel(product, opt) {
    if (product.price_varies) {
      var label = opt.fromLabel || 'From %s';
      return label.replace('%s', formatMoney(product.price_min, opt.moneyFormat));
    }
    return formatMoney(product.price, opt.moneyFormat);
  }

  var BAG_SVG =
    '<svg class="ee-product-rail__bag-svg" width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 7h12l-1 12H7L6 7z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><path d="M9 7V5.5A2.5 2.5 0 0111.5 3h1A2.5 2.5 0 0115 5.5V7" stroke="currentColor" stroke-width="1.5"/></svg>';

  // Mirrors snippets/ee-product-rail-card.liquid — keep the two in step.
  function buildCellHTML(product, opt) {
    var img = featuredImageSrc(product);
    var title = escapeHtml(product.title);
    var v = firstAvailableVariant(product);
    var href = (product.url || '/products/' + product.handle).split('?')[0];
    var price = priceLabel(product, opt);
    var quick = '';
    if (opt.showQuickAdd && v) {
      var disabled = v.available ? '' : ' disabled';
      quick =
        '<form method="post" action="' +
        escapeHtml(opt.cartAddUrl) +
        '" class="ee-product-rail__quick-form">' +
        '<input type="hidden" name="id" value="' +
        v.id +
        '"><input type="hidden" name="quantity" value="1">' +
        '<button type="submit" name="add" class="ee-product-rail__quick-add" data-ee-quick-add data-add-to-cart data-upsell-btn data-variant-id="' +
        v.id +
        '" data-variant-count="' +
        ((product.variants && product.variants.length) || 1) +
        '" data-product-handle="' +
        escapeHtml(product.handle || '') +
        '" data-product-title="' +
        title +
        '"' +
        disabled +
        ' aria-label="' +
        escapeHtml(opt.addLabel || 'Add to cart') +
        ': ' +
        title +
        '"><span class="ee-product-rail__quick-add-inner" aria-hidden="true">' +
        BAG_SVG +
        '</span></button></form>';
    }
    var imgBlock = img
      ? '<img class="ee-product-rail__image" src="' +
        escapeHtml(img) +
        '" alt="' +
        title +
        '" loading="lazy" width="900" height="900" />'
      : '<div class="ee-product-rail__placeholder"></div>';
    return (
      '<div class="ee-product-rail__cell">' +
      '<article class="ee-product-rail__card" data-product-id="' +
      product.id +
      '">' +
      '<div class="ee-product-rail__image-wrap">' +
      '<a href="' +
      escapeHtml(href) +
      '" class="ee-product-rail__image-link" tabindex="-1" aria-hidden="true">' +
      imgBlock +
      '</a>' +
      quick +
      '</div>' +
      '<a href="' +
      escapeHtml(href) +
      '" class="ee-product-rail__meta">' +
      '<h3 class="ee-product-rail__title">' +
      title +
      '</h3>' +
      '<p class="ee-product-rail__price">' +
      price +
      '</p>' +
      '</a></article></div>'
    );
  }

  var flickityByRoot = new WeakMap();

  function destroyFlickity(root) {
    var flkty = flickityByRoot.get(root);
    if (flkty && typeof flkty.destroy === 'function') {
      flkty.destroy();
    }
    flickityByRoot.delete(root);
  }

  function visibleCellCount(root) {
    var perRow = parseInt(root.getAttribute('data-products-per-row') || '4', 10);
    if (window.matchMedia('(max-width: 768px)').matches) {
      // a 50% slide shows two cards, 86% shows one
      var pct = parseFloat(root.getAttribute('data-mobile-cell-width')) || 86;
      return Math.max(1, Math.floor(100 / pct));
    }
    return Math.max(1, perRow);
  }

  function railIsScrollable(root, flkty) {
    if (!flkty || !flkty.cells || !flkty.cells.length) {
      return false;
    }
    return flkty.cells.length > visibleCellCount(root);
  }

  function updateRailNav(root, flkty) {
    var carousel = root.querySelector('[data-rail-carousel]');
    if (!carousel || !flkty) {
      return;
    }
    var scrollable = railIsScrollable(root, flkty);
    carousel.classList.toggle('is-scrollable', scrollable);

    var prev = carousel.querySelector('[data-rail-prev]');
    var next = carousel.querySelector('[data-rail-next]');
    if (!prev || !next) {
      return;
    }

    if (!scrollable) {
      prev.disabled = true;
      next.disabled = true;
      return;
    }

    prev.disabled = flkty.selectedIndex <= 0;
    next.disabled = flkty.selectedIndex >= flkty.slides.length - 1;
  }

  function bindRailNav(root, flkty) {
    var carousel = root.querySelector('[data-rail-carousel]');
    if (!carousel) {
      return;
    }

    if (root.getAttribute('data-rail-nav-ready') !== '1') {
      root.setAttribute('data-rail-nav-ready', '1');
      var prev = carousel.querySelector('[data-rail-prev]');
      var next = carousel.querySelector('[data-rail-next]');
      if (prev) {
        prev.addEventListener('click', function () {
          var active = flickityByRoot.get(root);
          if (active) {
            active.previous();
          }
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          var active = flickityByRoot.get(root);
          if (active) {
            active.next();
          }
        });
      }
    }

    flkty.on('select', function () {
      updateRailNav(root, flkty);
    });
    flkty.on('resize', function () {
      updateRailNav(root, flkty);
    });

    updateRailNav(root, flkty);
  }

  // phones in "two-column grid" mode lay the cells out with CSS; no carousel
  function mobileGrid(root) {
    return root.getAttribute('data-mobile-layout') === 'grid' && window.matchMedia('(max-width: 768px)').matches;
  }

  function initFlickity(root) {
    var Flk = flickityCtor();
    if (!Flk || mobileGrid(root)) {
      destroyFlickity(root);
      return;
    }
    var slider = root.querySelector('.ee-product-rail__slider');
    if (!slider) {
      return;
    }
    var n = root.querySelectorAll('.ee-product-rail__cell').length;
    if (n < 1) {
      return;
    }
    destroyFlickity(root);
    var isSmall = window.matchMedia('(max-width: 768px)').matches;
    var perRow = parseInt(root.getAttribute('data-products-per-row') || '4', 10);
    var groupCells = false;
    if (!isSmall && n > perRow) {
      groupCells = perRow;
    }

    var flkty = new Flk(slider, {
      cellSelector: '.ee-product-rail__cell',
      wrapAround: false,
      pageDots: false,
      contain: true,
      groupCells: groupCells,
      prevNextButtons: false,
      cellAlign: 'left',
      draggable: true,
      selectedAttraction: 0.045,
      friction: 0.32,
    });
    flickityByRoot.set(root, flkty);
    bindRailNav(root, flkty);
  }

  function readMoneyFormatFromDom(root) {
    var s = root.getAttribute('data-money-format');
    if (!s) {
      return '';
    }
    if (s.charAt(0) === '"' && s.charAt(s.length - 1) === '"') {
      try {
        return JSON.parse(s);
      } catch (e) {
        return s.slice(1, -1);
      }
    }
    return s;
  }

  function fetchJson(url) {
    return fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) {
      if (!r.ok) {
        throw new Error('HTTP ' + r.status);
      }
      return r.json();
    });
  }

  function getRecentHandles() {
    var raw;
    try {
      raw = window.localStorage.getItem('theme-recent');
    } catch (err) {
      return [];
    }
    if (!raw) {
      return [];
    }
    var o;
    try {
      o = JSON.parse(raw);
    } catch (e) {
      return [];
    }
    if (!o || typeof o !== 'object') {
      return [];
    }
    return Object.keys(o).filter(function (h) {
      return h && h !== 'undefined';
    });
  }

  function runRecommendations(root) {
    var pid = root.getAttribute('data-product-id');
    if (!pid) {
      return Promise.resolve();
    }
    var limit = parseInt(root.getAttribute('data-limit') || '8', 10);
    // root-prefixed so Shopify Markets locale paths (/en-fr/…) keep working
    var u =
      shopRoot() +
      'recommendations/products.json?product_id=' +
      encodeURIComponent(pid) +
      '&limit=' +
      encodeURIComponent(String(limit)) +
      '&intent=related';
    return fetchJson(u)
      .then(function (data) {
        return (data && data.products) || [];
      })
      .then(function (products) {
        renderFromProducts(root, products);
      });
  }

  function runRecentlyViewed(root) {
    var current = root.getAttribute('data-current-handle') || '';
    var limit = parseInt(root.getAttribute('data-limit') || '8', 10);
    var handles = getRecentHandles().filter(function (h) {
      return h !== current;
    });
    handles = handles.slice().reverse();
    if (handles.length > limit) {
      handles = handles.slice(0, limit);
    }
    if (handles.length === 0) {
      root.classList.add('ee-product-rail--hidden', 'ee-product-rail--empty');
      return Promise.resolve();
    }
    return Promise.all(
      handles.map(function (h) {
        return fetchJson(shopRoot() + 'products/' + encodeURIComponent(h) + '.js');
      })
    )
      .then(function (list) {
        return list.filter(function (p) {
          return p && p.handle && p.handle !== current;
        });
      })
      .then(function (products) {
        renderFromProducts(root, products);
      })
      .catch(function () {
        root.classList.add('ee-product-rail--hidden', 'ee-product-rail--empty');
      });
  }

  function bindResize(root) {
    if (root._eeResize) {
      window.removeEventListener('resize', root._eeResize);
    }
    var resizeT;
    root._eeResize = function () {
      clearTimeout(resizeT);
      resizeT = setTimeout(function () {
        initFlickity(root);
      }, 180);
    };
    window.addEventListener('resize', root._eeResize, { passive: true });
  }

  function renderFromProducts(root, products) {
    var track = root.querySelector('[data-rail-cells]');
    if (!track) {
      return;
    }
    var showQuick = root.getAttribute('data-show-quick') === 'true' || root.getAttribute('data-show-quick') === '1';
    var opt = {
      moneyFormat: readMoneyFormatFromDom(root),
      showQuickAdd: showQuick,
      fromLabel: root.getAttribute('data-from-label') || '',
      addLabel: root.getAttribute('data-add-label') || '',
      cartAddUrl:
        root.getAttribute('data-cart-add-url') ||
        (window.theme && window.theme.routes && window.theme.routes.cart_add_url) ||
        shopRoot() + 'cart/add',
    };

    if (!products || !products.length) {
      if (!track.querySelector('.ee-product-rail__cell')) {
        root.classList.add('ee-product-rail--hidden', 'ee-product-rail--empty');
      }
      return;
    }

    destroyFlickity(root);
    track.innerHTML = products
      .map(function (p) {
        return buildCellHTML(p, opt);
      })
      .join('');

    root.classList.remove('ee-product-rail--hidden', 'ee-product-rail--empty', 'ee-product-rail--loading');
    var skel = root.querySelector('.ee-product-rail__skeleton');
    if (skel) {
      skel.setAttribute('hidden', '');
    }

    requestAnimationFrame(function () {
      initFlickity(root);
      bindResize(root);
    });
  }

  function initRoot(root) {
    if (root.getAttribute('data-initialized') === '1') {
      return;
    }
    root.setAttribute('data-initialized', '1');

    if (root.querySelectorAll('.ee-product-rail__cell').length > 0) {
      var skel = root.querySelector('.ee-product-rail__skeleton');
      if (skel) {
        skel.setAttribute('hidden', '');
      }
      requestAnimationFrame(function () {
        initFlickity(root);
        bindResize(root);
      });
      return;
    }

    var mode = root.getAttribute('data-mode');
    if (mode === 'recommendations') {
      return runRecommendations(root).then(function () {
        if (!root.querySelector('.ee-product-rail__cell')) {
          root.classList.add('ee-product-rail--hidden', 'ee-product-rail--empty');
        }
      });
    }
    if (mode === 'recently_viewed') {
      return runRecentlyViewed(root);
    }
  }

  function boot() {
    document.querySelectorAll('.ee-product-rail[data-rail]').forEach(function (r) {
      var defer = parseInt(r.getAttribute('data-defer-millis') || '0', 10) || 0;
      if (r.getAttribute('data-mode') === 'recently_viewed') {
        defer = Math.max(defer, 200);
      }
      if (defer) {
        setTimeout(function () {
          initRoot(r);
        }, defer);
      } else {
        initRoot(r);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // theme editor re-renders
  document.addEventListener('shopify:section:load', boot);
})();
